<template>
  <div class="build-info text-caption text--secondary">
    <span>{{ buildId }}</span>
  </div>
</template>

<script>
import { BUILD_ID } from '@/generated/buildInfo'

export default {
  name: 'BuildInfo',

  computed: {
    buildId() {
      return BUILD_ID
    },
  },
}
</script>

<style scoped>
.build-info {
  font-size: 0.75rem;
  opacity: 0.6;
  font-family: 'Courier New', monospace;
}
</style>
